import { toast } from "react-toastify";
import { fetcheditPeerConfigurationFailure, fetcheditPeerConfigurationSuccess } from "./reducer";
import { setEditSuccessMessage } from "../../toastMessage/action";
import { PEER_CONFIGURATION_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { getAllPeerConfiguration } from "../thunk";

export const editPeerConfiguration = (jsonObj,ratingGroup,setLoading,setModalOpen) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${PEER_CONFIGURATION_API}/${ratingGroup}`, 'PUT', jsonObj).then((response) => {
        if (response.error) {
            dispatch(fetcheditPeerConfigurationFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
        if (!response.error) {
            dispatch(fetcheditPeerConfigurationSuccess(response))
            dispatch(setEditSuccessMessage(true))
            setModalOpen(false)
            dispatch(getAllPeerConfiguration(setLoading))
            setLoading(false)
        }
    }).catch((errorResp) => { })
};